import angular from "angular"
import "../edition/edition"
import "front-end-web-commons"
import "../../bower_components/front-end-web-commons/app/filter/filter"
import "../spreadsheet/spreadsheet"

export default angular.module("searchModule", ["nlgTableModule", "nlgTableDynamicColumnsModule", "nlgPaginationModule", "editionModule", "filterModule", "spreadsheetModule"])